import { styled, Switch as MUISwitch } from '@mui/material';
const Switch = styled(MUISwitch)(({ theme }) => ({
    width: 22,
    height: 13,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 1,
        transitionDuration: '200ms',
        '&.Mui-checked': {
            transform: 'translateX(8px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#4E3BC9',
                opacity: 1,
                border: 0,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#ECEFF1',
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 11,
        height: 11,
    },
    '& .MuiSwitch-track': {
        borderRadius: 13 / 2,
        backgroundColor: '#99A4AF',
        opacity: 1,
    },
}));
export default Switch;
